import { useCallback } from 'react';
import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';

export const useEnableSplitTest = () => {
  const { dispatch } = useCampaignEditorContext();

  return useCallback(
    (payload: { id: string; firstVariantId: string; secondVariantId: string }) => {
      dispatch({
        type: 'ENABLE_SPLIT_TEST',
        payload,
      });
    },
    [dispatch],
  );
};
